import qoalaStorage from '~/core/Storage';
import { parseIfJsonString } from '~/core/helper/JSONHelper';

export default {
  getPolicyList: state => {
    return state.policyList || [];
  },
  getClaimList: state => {
    return state.claimList;
  },
  getDocumentsType: state => {
    return qoalaStorage.getItem('documentsType')
      ? parseIfJsonString(qoalaStorage.getItem('documentsType'))
      : state.documentsType;
  },
  getOTAList: state => {
    const otaList = qoalaStorage.getItem('OTAList')
      ? parseIfJsonString(qoalaStorage.getItem('OTAList'))
      : JSON.parse(state.OTAList);
    return otaList || [];
  }
};
